import Image from 'next/image'
import { nextImageHelper } from 'utils/next-image-css-helper'

export const Loader: React.FC = () => {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col pt-2 sm:pt-0 text-center">
        <h2 className="px-10 sm:px-0 text-2xl sm:text-3xl font-serif font-bold text-primary leading-tight">
          Finding your perfect card match...
        </h2>
      </div>
      <Image
        src="/static/loader/cc-loader-wink.gif"
        alt="Loading animation"
        width={88}
        height={112}
        style={nextImageHelper.intrinsic}
        priority
      />
    </div>
  )
}
